import React from 'react';

//@Packages
import { Button, Modal } from '@forge/common';
import { useTranslation } from 'react-i18next';

//@Utils
import { LOCALE_CONST } from '../../../utils/constants';

interface ConnectConfirmModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	title: string;
	content: string;
	footerLeftButtonText?: string;
	footerRightButtonText?: string;
	confirmButtonVariant?: any;
}

const ConnectConfirmModal: React.FC<ConnectConfirmModalProps> = ({
	isOpen,
	onClose,
	onConfirm,
	title,
	content,
	footerLeftButtonText,
	footerRightButtonText,
	confirmButtonVariant
}) => {
	const { t } = useTranslation();

	return (
		<>
			{
				isOpen && (
					<Modal
						backdrop
						title={title}
						onBackdropClick={onClose}
						onModalClose={onClose}
					>
						<div className="confirmation-modal-content">{content}</div>
						<div className="confirmation-modal-footer">
							<Button onClick={onClose} variant="secondary">
								{footerLeftButtonText || t(LOCALE_CONST.cancel)}
							</Button>
							<Button onClick={onConfirm} className="iot-connect-confirm-button-cls" variant={confirmButtonVariant || 'primary'}>
								{footerRightButtonText || t(LOCALE_CONST.confirm)}
							</Button>
						</div>
					</Modal>
				)
			}
		</>
	);
};

export default ConnectConfirmModal;